import { render, staticRenderFns } from "./LandsideHeader.vue?vue&type=template&id=2bf07f5d&"
import script from "./LandsideHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports